export const USER_DASHBOARDS_URL_ROOT = 'user-dashboards';
